import { useState } from 'react';
import { Navigate } from 'react-router-dom';

import { useRequiredSession } from '@/hooks/useRequiredSession';
import { SessionGateScreen } from '@/components/SessionGateScreen';
import { UserSettingsForm } from '@/components/UserSettingsForm';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

export default function OnboardingPage() {
  const { status, user, updateUser, retry } = useRequiredSession();
  const [saved, setSaved] = useState(false);

  if (status === 'error') {
    return <SessionGateScreen onRetry={retry} />;
  }

  if (status !== 'ready') {
    return null;
  }

  if (saved || user?.onboardingCompleted) {
    return <Navigate to="/meaning" replace />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Welcome to Yawca</CardTitle>
          <CardDescription>
            Tell us your languages so we can tailor your learning experience.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <UserSettingsForm
            submitLabel="Get started"
            onSaved={(updated) => {
              updateUser(updated);
              setSaved(true);
            }}
          />
        </CardContent>
      </Card>
    </div>
  );
}
